// Decides how the product-delete confirmation behaves for the account's
// location count. "Remove from this location" and "delete from the account"
// only make a meaningful choice when there is more than one location.

export type DeleteScopeMode = 'choice' | 'account' | 'single';

// usrLocations is the locID -> locName map from the "me" state; for web admins
// it holds every enabled location of the account. Unknown or empty keeps the
// choice visible.
export function isSingleLocation(usrLocations: any): boolean {
  if (!usrLocations || typeof usrLocations !== 'object') { return false; }
  return Object.keys(usrLocations).length === 1;
}

export function deleteScopeMode(deleteScopeChoice: boolean, isAdmin: boolean, usrLocations: any): DeleteScopeMode {
  if (!deleteScopeChoice) { return 'single'; }
  if (!isAdmin) { return 'single'; }
  return isSingleLocation(usrLocations) ? 'account' : 'choice';
}
